import { createAction } from '@reduxjs/toolkit';
import { IZona } from '../../../interfaces/place/models';
import { EMPTY, GET, IZonaState, LIST } from './types';

export const listAction = createAction<IZonaState>(LIST);

export const getAction = createAction<IZona>(GET);

export const emptyAction = createAction(EMPTY);

